import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  QuizCurrentResponse,
  QuizFeedbackItem,
  QuizSharePlatform,
  QuizShareResponse,
  QuizSubmitResponse,
  QuizYearHistoryResponse,
} from '../models/quiz.models';

@Injectable({
  providedIn: 'root',
})
export class QuizService {
  private http = inject(HttpClient);

  fetchCurrent(): Observable<QuizCurrentResponse> {
    return this.http.get<QuizCurrentResponse>('/api/quiz/current');
  }

  checkAnswer(quizId: number, quizQuestionId: number, answerId: number): Observable<QuizFeedbackItem> {
    return this.http.post<QuizFeedbackItem>(`/api/quiz/${quizId}/check-answer`, {
      quiz_question_id: quizQuestionId,
      answer_id: answerId,
    });
  }

  submitCompletion(quizId: number, answers: {quiz_question_id: number; answer_id: number}[]): Observable<QuizSubmitResponse> {
    return this.http.post<QuizSubmitResponse>(`/api/quiz/${quizId}/complete`, {answers});
  }

  recordShare(completionId: number, platform: QuizSharePlatform): Observable<QuizShareResponse> {
    return this.http.post<QuizShareResponse>(`/api/quiz/completions/${completionId}/share`, {platform});
  }

  fetchYearHistory(year: number): Observable<QuizYearHistoryResponse> {
    return this.http.get<QuizYearHistoryResponse>(`/api/quiz/history/${year}`);
  }
}
